module.exports = __webpack_public_path__ + "media/bootstrap-icons/signpost-2-fill-a96fa038.svg";